// eslint-disable-next-line @typescript-eslint/no-unused-vars
type StringOfLength<Min, Max> = string & {
  __value__: never;
};

// Type guard function
const isStringOfLength = <Min extends number, Max extends number>(
  str: string,
  min: Min,
  max: Max,
): str is StringOfLength<Min, Max> => str.length >= min && str.length <= max;

// type constructor function
export const stringOfLength = <Min extends number, Max extends number>(
  input: unknown,
  min: Min,
  max: Max,
): StringOfLength<Min, Max> => {
  if (typeof input !== 'string') {
    throw new Error('invalid input');
  }

  if (!isStringOfLength(input, min, max)) {
    throw new Error(`input is not between specified ${min} and ${max}`);
  }

  return input;
};
